// Favorites!!
function fnc_fav_init() {
  //console.log('fav-fun-call');
  
  jQuery(".fnc-fav").each(function () {
    jQuery(this).on("vmousedown click", function (e) {
      e.preventDefault();

      var this_btn = jQuery(this);

      var data_otype = jQuery(this_btn).data("otype");
      var data_oid = jQuery(this_btn).data("oid");
      var data_clearparent = jQuery(this_btn).data("clear-parent");

      jQuery.ajax({
        url: nlTheme.ajaxurl,
        type: "post",
        dataType: "json",
        data: {
          action: "_fav_btn",
          otype: data_otype,
          oid: data_oid,
          clearparent: data_clearparent,
          lang: nlTheme.lang,
        },

        success: function (response) {
          if (response.data.action == "deleted") {
            if (data_clearparent !== undefined && data_clearparent != "")
              jQuery(this_btn).closest(data_clearparent).remove();

            jQuery(this_btn).removeClass("fav-on");
          } else if ("added" == response.data.action) {
            jQuery(this_btn).addClass("fav-on");
          }

          var dataCounters = Object.entries(response.data.counters);
          for (let [keyCounter, valueCounter] of dataCounters) {
            jQuery(".fav-counter-" + keyCounter)
              .replaceWith(valueCounter)
              .closest("a")
              .removeClass("fav-on");
            if (response.data.counters_n[keyCounter] > 0) {
              jQuery(".fav-counter-" + keyCounter)
                .closest("a")
                .addClass("fav-on");
            }
          }

          // Check for specific counters
          const counters = response.data.counters_n;

          // Hide .all-collection-wrap if "collection" is 0
          if (counters.collection == 0) {
            jQuery(".collection-fav-grid").hide();
            //console.log('coll-gone');
            
          } else {
            jQuery(".collection-fav-grid").show();
            //console.log(counters.collection);
          }

          // Hide .product-fav-grid if "product" is 0
          if (counters.product == 0) {
            jQuery(".product-fav-grid").hide();
            //console.log('prod-gone');
            
          } else {
            jQuery(".product-fav-grid").show();
            //console.log(counters.product);
            
          }
          
          if (counters.total == 0) {
            jQuery(".fav-no-results").addClass('visible');
            jQuery(".fav-grid-download").addClass('hide');
          } else {
            jQuery(".fav-no-results").removeClass('visible');
            jQuery(".fav-grid-download").removeClass('hide');
          }         
        },

        error: function (response) {
          console.log("Error en la petición");
        },
      });

      return false;
    });
  });

  jQuery(".fav-counter-total").each(function () {
    if (jQuery(this).text() > 0) jQuery(this).closest("a").addClass("fav-on");
  });
}


export { 
  fnc_fav_init
};